import React, { Component } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Tab,
  Nav,
  Button,
  Card,
  Spinner,
  Modal,
} from "react-bootstrap";
import gql from "graphql-tag";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";
import { components } from "react-select";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import MultiSelect from "react-multi-select-component";
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";
import moment from "moment";
import "./_adaptive_exams.scss";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { canEdit, canDelete } from "../../../utils/modulePermissions";

// Role permissions for this page. Adaptive Exams has no grant row of its own, so it
// rides on Exam_Made_Easy ("Exam Creation") — it is an exam-creation flow and sits in
// the same "Online Exams" sidebar group.
//
// Match on module_key ONLY, never on module_name: "Online Exams" is the GROUP shared
// by Exam_Made_Easy, Manage_Exams, Quiz and View_Results, and can() allows an action
// when ANY matched row grants it — so matching the group name would let a role with
// edit on a sibling module inherit edit here.
const ADAPTIVE_EXAMS_MODULE = ["Exam_Made_Easy"];

// Where the in-flight exam-creation job id is parked so the progress modal can resume
// after a reload.
//
// This used to be a single global key, "adaptive_job_id". It is written to
// localStorage (which survives logout) and is not tied to anyone, so a job queued by
// an admin was picked up by whoever opened this page next in the same browser — a
// view-only role would land here, componentDidMount would resume the poll, and the
// modal would run through to "Exams Created Successfully!" with the exams appearing.
// That looks exactly like the Access Denied guard being bypassed, even though the
// exams were created by the admin's earlier job and not by their blocked click.
//
// Scoping the key to the institution + user id keeps one user's job out of another's
// session.
const jobStorageKey = () =>
  `adaptive_job_id_${Cookies.get("institutionid") || ""}_${Cookies.get("id") || ""}`;

// The old un-scoped key. Cleared on mount so a job left behind by a previous session
// can't keep leaking into this one.
const LEGACY_JOB_KEY = "adaptive_job_id";

const DropdownIndicator = (props) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <svg height="20" width="20" viewBox="0 0 20 20">
        <path fill="currentColor" d="M4.516 7.548l5.484 5.452 5.484-5.452" />
      </svg>
    </components.DropdownIndicator>
  );


const ExamData = [
  {
    value: 1,
    label: "Previous Paper 2030"
  },
  {
    value: 2,
    label: "Previous Paper 2030"
  },
  {
    value: 3,
    label: "Previous Paper 2030"
  },
  {
    value: 4,
    label: "Previous Paper 2030"
  }
]

class CreateAdaptiveExams extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nameValue: null,
      branchValue: [],
      examValue: null,
      classTypeValue: null,
      remedialExamValue: null,
      sectionValue: [],
      studentValue: [],
      chapterCountsData: [],
      showChapterCountsData: false,
      showChapterDetailedData: false,
      chapterDetailedData: [],
      branchTypeOptions: [],
      examTypeOptions: [],
      classOptions: [],
      sectionOptions: [],
      studentOptions: [],
      studentOptionsCopy: [],
      chapterWiseStudentOriginalData: [],
      chapterwiseStudents: [],
      sectionOptionsCopy: [],
      selectedYearValue: [],
      typeValue: "adaptive_exams",
      previousYearOptions: [
        { value: 2025, label: "2025" },
        { value: 2024, label: "2024" },
        { value: 2023, label: "2023" },
        { value: 2022, label: "2022" },
        { value: 2021, label: "2021" },
        { value: 2020, label: "2020" },
        { value: 2019, label: "2019" },
        { value: 2018, label: "2018" },
        { value: 2017, label: "2017" },
        { value: 2016, label: "2016" },
        { value: 2015, label: "2015" },
        { value: 2014, label: "2014" },
      ],
      articlecolumns: [
        { dataField: "exam_name", text: "Exam Type", sort: true },
        { dataField: "name", text: "Exam", sort: true },
        { dataField: "branch", text: "Branch", sort: true },
        { dataField: "class", text: "Class", sort: true },
        { dataField: "section", text: "Section", sort: true },
        { dataField: "conducted_on", text: "Conducted On", sort: true },
        { dataField: "time", text: "Time", sort: true },
        { dataField: "is_completed", text: "Status", sort: true },

        {
          dataField: "view",
          formatter: this.viewFormatter,
          headerAlign: "center",
        },
        {
          dataField: "edit",
          formatter: this.editFormatter,
          headerAlign: "center",
        },
        {
          dataField: "delete",
          formatter: this.deleteFormatter,
          headerAlign: "center",
        },
      ],

      manageQuestions: [],
      loading: false,

      adaptiveSubTab: "manage_adaptive_exams",
      remedialSubTab: "manage_remedial_exams",
      selectedScheduleType: null,
      selectedScheduleSubType: null,
      selectedAdaptiveTypeId: null,
      adaptiveScheduledTypes: props?.getExamScheduleSubTypeQuestions || [],
      examCreationMessage: "",
      studentExamPercErrorArr: [],
      adaptiveReportData: [],
      chapterCountsData: [],
      showChapterCountsData: false,
      showChapterDetailedData: false,
      chapterDetailedData: [],
      showPreviewModal: false,
      previewLoading: false,
      activeStudentIndex: 0,
      errorViewType: "greater", // greater | lesser
      questionPaperType: null,
      errorRange: { from: 0, to: 0 },
      dynamicColumns: [],
      dynamicTableData: [],
      prevPapValue: null,
      showPrevPap: false,
      isPreviousPaper: false,
      previousPaperData: [],
      subjectOptions: [],
      subjectValue: null,
      noOfQuestionsValue: "",
      chaptersData: [],
      chapterValues: [],
      examNotConductedStundets: [],
      jobId: null,
      jobStatus: null,
      jobProgress: 0,
      jobTotal: 0,
      jobError: null,
      showJobModal: false,

      // Shown when a role without is_edit / is_delete clicks an action.
      accessDeniedShow: false,
    };

    this.tableRef = React.createRef();
    this.pollingInterval = null;
  }

  // ── Role-based access control ───────────────────────────────────────────────
  // The buttons stay VISIBLE and enabled for a view-only role — nothing is hidden,
  // disabled or redirected away. The click is allowed through, the grant is checked,
  // and a missing grant opens the Access Denied modal instead of performing the
  // action. Reads (the "Submit" weak-area preview, the row "view") are not gated;
  // only the writes are.
  //
  // Admins (userlevel 1/2) and roles with no configured grants keep full access —
  // see can() in utils/modulePermissions.
  showAccessDenied = () => this.setState({ accessDeniedShow: true });
  hideAccessDenied = () => this.setState({ accessDeniedShow: false });

  // Each returns false and pops the modal when the grant is missing, so callers
  // read as: `if (!this.requireEdit()) return;`
  requireEdit = () => {
    if (canEdit(ADAPTIVE_EXAMS_MODULE)) return true;
    this.showAccessDenied();
    return false;
  };

  requireDelete = () => {
    if (canDelete(ADAPTIVE_EXAMS_MODULE)) return true;
    this.showAccessDenied();
    return false;
  };

  errorRangeTypeOptions = [
    {
      value: 0,
      label: "1-10%"
    },
    {
      value: 1,
      label: "11-20%"
    },
    {
      value: 2,
      label: "21-30%"
    },
    {
      value: 3,
      label: "31-40%"
    },
    {
      value: 4,
      label: "41-50%"
    },
    {
      value: 5,
      label: "51-60%"
    },
    {
      value: 6,
      label: "61-70%"
    },
    {
      value: 7,
      label: "71-80%"
    },
    {
      value: 8,
      label: "81-90%"
    },
    {
      value: 9,
      label: "91-100%"
    }
  ]

  handleStudentCountClick = (row) => {
    // 🔍 Find selected group (NOT filter)
    const selectedGroup = this.state.adaptiveReportData.find(
      (item) => item.value === row.value
    );

    if (!selectedGroup) {
      console.log("❌ No matching group found");
      return;
    }

    const students = selectedGroup.student_detailed || [];
    const flatData = [];

    students.forEach((student) => {
      const chapters = student?.chapters || [];

      // ✅ If no chapters
      if (chapters.length === 0) {
        flatData.push({
          name: student.name,
          mobile: student.mobile,
          chapter_id: "-",
          chapter: "-",
          value: "-",
        });
      } else {
        // ✅ Flatten chapters
        chapters.forEach((c) => {
          flatData.push({
            name: student.name,
            mobile: student.mobile,
            chapter_id: c.chapter_id,
            chapter: c.chapter,
            value: c.value,
          });
        });
      }
    });

    console.log("✅ flatData:", flatData);

    this.setState(
      {
        showChapterDetailedData: true,
        chapterDetailedData: flatData,
      },
      () => {
        setTimeout(() => {
          if (this.tableRef?.current) {
            this.tableRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          } else {
            // Fallback for scrolling if the ref isn't attached yet
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 150);
      }
    );
  };



  resetForm = () => {
    this.setState({
      nameValue: null,
      branchValue: [],
      examValue: null,
      classTypeValue: null,
      remedialExamValue: null,
      sectionValue: [],
      studentValue: [],
      examCreationMessage: "",
      studentExamPercErrorArr: [],
      showPreviewModal: false,
      previewLoading: false,
      activeStudentIndex: 0,
      errorViewType: "greater", // greater | lesser
    });
  };

  componentDidMount() {
    const { globals, students = [] } = this.props;
    if (!globals) return;

    const {
      globalBranches = [],
      exams = [],
      classes = [],
      globalSections = [],
    } = globals;

    this.setState({
      branchTypeOptions: globalBranches.map((b) => ({
        label: b.branch_name,
        value: b.id,
      })),

      examTypeOptions: exams.map((e) => ({
        label: e.exam,
        value: e.id,
      })),

      classOptions: classes.map((c) => ({
        label: c.class,
        value: c.id,
      })),

      sectionOptions: globalSections.map((s) => ({
        label: s.section_name,
        value: s.id,
        branch_id: s.branch_id
      })),
      sectionOptionsCopy: globalSections.map((s) => ({
        label: s.section_name,
        value: s.id,
      })),

      studentOptions: students.map((s) => ({
        label: s.student_name,
        value: s.id,
        section_id: s.section_id,
        branch_id: s.branch_id,
        class_id: s.class_id,
        exam_id: s.exam_id,
        mobile: s.mobile,
      })),
      studentOptionsCopy: students.map((s) => ({
        label: s.student_name,
        value: s.id,
        section_id: s.section_id,
        branch_id: s.branch_id,
        class_id: s.class_id,
        exam_id: s.exam_id,
        mobile: s.mobile,
      })),
    });

    // Drop any job left under the old global key by an earlier session — see
    // jobStorageKey. Without this, the stale id keeps being resumed by whoever opens
    // the page next.
    localStorage.removeItem(LEGACY_JOB_KEY);

    const savedJobId = localStorage.getItem(jobStorageKey());
    if (savedJobId) {
      // Only a role that may create exams resumes a creation job. A view-only role
      // has no business watching one run to completion — and showing them the
      // progress modal is what made it look like their blocked click still created
      // the exam.
      if (canEdit(ADAPTIVE_EXAMS_MODULE)) {
        this.setState({ jobId: savedJobId, jobStatus: "pending" });
        this.startJobPolling(savedJobId);
      } else {
        localStorage.removeItem(jobStorageKey());
      }
    }
  }

  componentWillUnmount() {
    this.stopJobPolling();
  }

  stopJobPolling = () => {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  };

  startJobPolling = (jobId) => {
    localStorage.setItem(jobStorageKey(), jobId);
    this.pollingInterval = setInterval(async () => {
      try {
        const res = await this.props.client.query({
          query: gql`
            query GetAdaptiveJobStatus($jobId: String!) {
              getAdaptiveExamJobStatus(jobId: $jobId) {
                status
                progress
                total
                error
                results {
                  exam_paper_id
                  filename
                }
              }
            }
          `,
          variables: { jobId },
          fetchPolicy: "network-only",
        });

        const job = res?.data?.getAdaptiveExamJobStatus;
        if (!job) return;

        this.setState({ jobProgress: job.progress, jobTotal: job.total, jobStatus: job.status, jobError: job.error });

        if (job.status === "done") {
          this.stopJobPolling();
          localStorage.removeItem(jobStorageKey());
          this.setState({ loading: false, jobStatus: "done" });
        } else if (job.status === "failed") {
          this.stopJobPolling();
          localStorage.removeItem(jobStorageKey());
          this.setState({ loading: false, jobStatus: "failed", jobError: job.error || "Exam creation failed" });
        }
      } catch (err) {
        this.stopJobPolling();
        localStorage.removeItem(jobStorageKey());
        this.setState({ loading: false, jobStatus: "failed", jobError: err.message || "Error checking job status" });
      }
    }, 60000);
  };

  getTableExams = (data = []) =>
    data.map((item) => {
      let status = "";

      if (item.is_completed === 0) status = "Not completed";
      else if (item.is_completed === 1) status = "Completed";
      else if (item.is_completed === 2) status = "On going";

      return {
        id: item.id,
        exam_name: item.exam_name,
        name: item.name,
        branch: item.branch,
        class: item.class,
        section: item.section,

        conducted_on: moment.unix(item.start_time).format("YYYY/MM/DD"),
        time: moment.unix(item.start_time).format("LT"),

        is_completed: status,
      };
    });

  viewFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-theme"
        onClick={() => this.handleView(row)}
      >
        <i className="far fa-eye" />
      </Button>
    </div>
  );

  editFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-theme"
        onClick={() => this.handleEdit(row)}
      >
        <i className="far fa-edit" />
      </Button>
    </div>
  );

  deleteFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-danger"
        onClick={() => this.handleDelete(row)}
      >
        <i className="far fa-trash-alt" />
      </Button>
    </div>
  );

  handleView = (row) => {
    this.props.history.push(
      "/questions/manage-question-paper/question-paper-result",
      {
        exam_id: row.id,
        is_completed: row.is_completed,
      }
    );
  };

  // Navigation gated on the grant. Checked BEFORE history.push, otherwise react-router
  // would have already moved the user into the target page and the check would come
  // too late to stop anything.
  handleEdit = (row) => {
    if (!this.requireEdit()) return;

    this.props.history.push(
      "/questions/manage-question-paper/question-paper-result",
      {
        exam_id: row.id,
        is_completed: row.is_completed,
      }
    );
  };

  handleDelete = (row) => {
    if (!this.requireDelete()) return;

    this.props.handleDelete({
      variables: { exam_paper_id: row.id },
      refetchQueries: ["FETCH_EXAMS"],
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name + "Value"]: value,
      showChapterCountsData: false,
      showChapterDetailedData: false,
    });
  };

  selecthandleInputChange = (name, value, selectedOption) => {
    this.setState({
      [name + "Value"]: selectedOption,
      showChapterCountsData: false,
      showChapterDetailedData: false,
    });

    if (name === "subject") {
      if (!selectedOption) {
        this.setState({ chaptersData: [], chapterValues: [] });
        return;
      }
      const selectedId = String(selectedOption.value);
      const filteredSubjects = this.state.previousPaperData.filter(sub => String(sub.id) === selectedId);
      let chapters = [];
      filteredSubjects.forEach(sub => {
        if (sub.chapters) {
          sub.chapters.forEach(ch => {
            chapters.push({ value: ch.id, label: ch.chapter });
          });
        }
      });
      const uniqueChaptersMap = new Map();
      chapters.forEach(c => uniqueChaptersMap.set(c.value, c));
      chapters = Array.from(uniqueChaptersMap.values());

      this.setState({
         chaptersData: chapters,
         chapterValues: [], // Reset chapters on subject change
         chapterwiseStudents: this.state.studentOptionsCopy, // seed students for prev paper
         studentValue: [],
      });
    }
  };

  handleCheckboxChange = (e, item) => {
    let selected = [...(this.state.prevPapValue || [])];

    if (e.target.checked) {
      selected.push(item);
    } else {
      selected = selected.filter((val) => val.value !== item.value);
    }

    this.setState({ prevPapValue: selected });
  };

  handleMultipleSelectInputChange = (selected, name) => {
    console.log("selected", name + "Value", selected, name);
    this.setState({
      [name + "Value"]: selected,
      showChapterCountsData: false,
      showChapterDetailedData: false,

    });

    if (name === "branch") {
      const selectedIds = selected.map((s) => parseInt(s.value));

      const filteredSections = this.state.sectionOptions.filter((s) =>
        selectedIds.includes(parseInt(s.branch_id))
      );
      console.log("filteredSections", selectedIds, filteredSections, this.state.sectionOptions);
      this.setState({
        branchValue: selected, // store selected branches
        sectionOptionsCopy: filteredSections,
        sectionValue: [],
        studentValue: [],
      });
    }
    if (name === "section") {
      const selectedIds = selected.map((s) => parseInt(s.value));

      const filteredStudents = this.state.studentOptions.filter((s) =>
        selectedIds.includes(parseInt(s.section_id))
      );
      const examBasedStudents = filteredStudents.filter((s) => s.exam_id === parseInt(this.state.examValue?.value))


      this.setState({
        sectionValue: selected, // store selected sections
        studentOptionsCopy: examBasedStudents,
        studentValue: [],
      });
    }
    if (name === "chapter") {
      if (this.state.isPreviousPaper) {
        this.setState({ chapterValues: selected });
        return;
      }
      const selectedIds = selected.map((s) => parseInt(s.value));
      const selectedChapterNames = selected.map(s => s.label);

      // Filter students who have at least one of the selected chapters
      const filteredStudentsRaw = this.state.chapterWiseStudentOriginalData.filter((student) =>
        student.chapters && student.chapters.some((ch) =>
          selectedIds.includes(parseInt(ch.chapter_id))
        )
      );

      // ✅ Re-generate Table Data specifically for selected chapters
      let tableData = [];
      filteredStudentsRaw.forEach((student) => {
        const row = {
          name: student.label,
          mobile: student.value,
          chapter_count: student.chapterCount || student.chapters?.length || 0,
        };

        // initialize selected chapters with "-"
        selectedChapterNames.forEach((chapter) => {
          row[chapter] = "-";
        });

        // fill actual values
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            if (selectedChapterNames.includes(ch.chapter)) {
              row[ch.chapter] = ch.error_count;
            }
          });
        }
        tableData.push(row);
      });

      // ✅ Re-generate Dynamic Columns specifically for selected chapters
      const dynamicColumns = [
        { dataField: "name", text: "Student Name", sort: true },
        { dataField: "mobile", text: "Mobile", sort: true },
        {
          dataField: "chapter_count",
          text: "Chapter Count",
          sort: true,
          formatter: (cell) => <span style={{ fontWeight: "600" }}>{cell}</span>,
        },
        ...selectedChapterNames.map((chapter) => ({
          dataField: chapter,
          text: chapter.slice(0, 20),
          sort: true,
          headerFormatter: (column) => (
            <span title={chapter} style={{ cursor: "pointer" }}>{column.text}</span>
          ),
          formatter: (cell) => {
            if (cell === "-") return "-";
            return (
              <span
                title={`${chapter} - ${cell}%`}
                style={{ color: cell > 50 ? "red" : "green", cursor: "pointer" }}
              >
                {cell}%
              </span>
            );
          },
        })),
      ];

      console.log("Filtered Preview Data:", tableData);

      this.setState({
        chapterValues: selected,
        chapterwiseStudents: filteredStudentsRaw,
        dynamicTableData: tableData,
        dynamicColumns: dynamicColumns,
        showChapterCountsData: false,
        showChapterDetailedData: true,
        studentValue: filteredStudentsRaw,
      });
    }
    if (name === "student") {
      const selectedIds = selected.map((s) => parseInt(s.value));
      console.log("Selected IDs:", selectedIds);
      const selectedChapters = this.state.chapterValues;

      // Filter based on the selected students from the master data
      const filteredStudentsRaw = this.state.chapterWiseStudentOriginalData.filter((student) =>
        selectedIds.includes(parseInt(student.value))
      );
      const examNotConductedStundets = this.state.chapterWiseStudentOriginalData.filter((student) =>
        !selectedIds.includes(parseInt(student.value))
      );

      // ✅ Re-generate Table Data for the specifically selected students
      let tableData = [];
      filteredStudentsRaw.forEach((student) => {
        const row = {
          name: student.label,
          mobile: student.value,
          chapter_count: student.chapterCount || student.chapters?.length || 0,
        };

        // initialize columns with "-"
        selectedChapters.forEach((ch) => {
          row[ch.value] = "-";
        });

        // fill specific error values for this student
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            if (row.hasOwnProperty(ch.chapter_id)) {
              row[ch.chapter_id] = ch.error_count;
            }
          });
        }
        tableData.push(row);
      });
      const chapterMap = new Map();

      examNotConductedStundets.forEach((student) => {
        if (student.chapters && student.chapters.length) {
          student.chapters.forEach((ch) => {
            if (!chapterMap.has(ch.chapter_id)) {
              chapterMap.set(ch.chapter_id, ch.chapter);
            }
          });
        }
      });

      const allChapters = Array.from(chapterMap, ([id, name]) => ({
        value: id,
        label: name,
      }));
      // ✅ Re-generate Dynamic Columns based on currently selected chapters
      const dynamicColumns = [
        { dataField: "name", text: "Student Name", sort: true },
        { dataField: "mobile", text: "Mobile", sort: true },
        {
          dataField: "chapter_count",
          text: "Chapter Count",
          sort: true,
          formatter: (cell) => <span style={{ fontWeight: "600" }}>{cell}</span>,
        },
        ...allChapters.map((ch) => ({
          dataField: ch.value, // ✅ chapter_id
          text: ch.label.slice(0, 20),
          sort: true,
          headerFormatter: () => (
            <span title={ch.label} style={{ cursor: "pointer" }}>
              {ch.label.slice(0, 20)}
            </span>
          ),
          formatter: (cell) => {
            if (cell === "-") return "-";
            return (
              <span
                title={`${ch.label} - ${cell}%`}
                style={{ color: cell > 50 ? "red" : "green", cursor: "pointer" }}
              >
                {cell}%
              </span>
            );
          },
        })),
      ];

      console.log("Filtered Student Preview Data:", examNotConductedStundets);
      const examNotConductedStundetsData = examNotConductedStundets.map((student) => {
        const row = {
          name: student.label,
          mobile: student.value,
          chapter_count: student.chapterCount || student.chapters?.length || 0,
        };
        allChapters.forEach((ch) => {
          row[ch.value] = "-";
        });
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            if (row.hasOwnProperty(ch.chapter_id)) {
              row[ch.chapter_id] = ch.error_count;
            }
          });
        }
        return row;
      });

      this.setState({
        studentValue: selected,
        dynamicTableData: tableData,
        dynamicColumns: dynamicColumns,
        showChapterCountsData: false,
        showChapterDetailedData: true,
        examNotConductedStundets: examNotConductedStundetsData,
      });
    }
  };


  handleForExamCreationForAdaptive = async () => {
    this.setState({ examCreationMessage: "" });
    const {
      errorRange,
      branchValue,
      examValue,
      classTypeValue,
      selectedScheduleSubType,
      selectedScheduleType,
      selectedAdaptiveTypeId,
      sectionValue,
      nameValue
    } = this.state;

    if (!selectedScheduleSubType) {
      toast.error("Please select exam type");
      return;
    }
    if (nameValue == "") {
      toast.error("Please enter exam name");
      return;
    }
    if (!errorRange.from && !errorRange.to && selectedScheduleSubType == "4") {
      toast.error("Please select error range");
      return;
    }

    if (!selectedScheduleType) {
      toast.error("Please select schedule type");
      return;
    }
    if (!sectionValue?.length) {
      toast.error("Please select sections");
      return;
    }

    if (this.state.isPreviousPaper) {
      if (!this.state.selectedYearValue || this.state.selectedYearValue.length === 0) {
        toast.error("Please select years");
        return;
      }
      this.setState({ previewLoading: true });
      try {
        const reportResponse = await this.props.client.query({
          query: gql`
            query($exam_id: Int!, $years: [Int]) {
              getAdaptiveReportForPreviousPapers(exam_id: $exam_id, years: $years) {
                id
                subject
                count
                chapters {
                  id
                  chapter
                  count
                }
              }
            }
          `,
          variables: {
            exam_id: parseInt(examValue.value),
            years: this.state.selectedYearValue.map(y => parseInt(y.value))
          },
          fetchPolicy: "network-only"
        });

        const apiResult = reportResponse?.data?.getAdaptiveReportForPreviousPapers || [];
        if (apiResult.length === 0) {
          toast.error("No Data found for selected years");
          this.setState({ previewLoading: false });
          return;
        }

        const subjects = apiResult.map(sub => ({
          label: sub.subject,
          value: sub.id
        }));

        this.setState({
          previousPaperData: apiResult,
          subjectOptions: subjects,
          subjectValue: null,
          chapterValues: [],
          chaptersData: [],
          previewLoading: false,
        });
      } catch (err) {
        console.error(err);
        this.setState({ previewLoading: false });
        toast.error(err.message || "Something went wrong fetching previous paper info");
      }
      return;
    }

    this.setState({ previewLoading: true });
    console.log(examValue, classTypeValue, sectionValue, "examValue")

    try {
      const response = await this.props.client.query({
        query: gql`
      query($type: Int!,$branch_id: [Int]!,$exam_id: Int!,$class_id: Int!,$section_id: [Int]!, $startRange: Int, $endRange: Int, $chapterIds: [Int]){
        getAdaptiveReport1(
          type: $type
          branch_id: $branch_id
          exam_id: $exam_id
          class_id: $class_id
          section_id: $section_id
          startRange: $startRange
          endRange: $endRange
          chapterIds: $chapterIds
        ) {
          
          report {
          student_id
            student_name
            student_mobile
            total_chapter
            student_id
            chapters {
              chapter_id
              chapter
              error_count
            }
          }
        }
      }
      `,
        variables: {
          type: parseInt(selectedScheduleSubType) === 4 ? 2 : parseInt(selectedScheduleSubType),
          branch_id: branchValue.map((s) => parseInt(s.value)),
          exam_id: parseInt(examValue.value),
          class_id: parseInt(classTypeValue.value),
          section_id: sectionValue.map((s) => parseInt(s.value)),
          startRange: parseInt(errorRange.from || 0),
          endRange: parseInt(errorRange.to || 0),
          chapterIds: [],
        },
        fetchPolicy: "network-only"
      });

      console.log(response, "response");

      const apiResult = response?.data?.getAdaptiveReport1 || {};
      const reportData = apiResult.report || [];

      // Extract unique chapters from all students' chapter arrays
      const chaptersMap = new Map();
      reportData.forEach((student) => {
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            if (!chaptersMap.has(ch.chapter_id)) {
              chaptersMap.set(ch.chapter_id, { value: ch.chapter_id, label: ch.chapter });
            }
          });
        }
      });
      const chaptersDataExtracted = Array.from(chaptersMap.values());

      const studentsData = reportData.map((s) => ({ value: s.student_id, label: s.student_name, chapterCount: s.total_chapter, chapters: s.chapters }))
      console.log(chaptersDataExtracted, "chaptersData");
      this.setState({
        chaptersData: chaptersDataExtracted,
        chapterwiseStudents: studentsData,
        chapterWiseStudentOriginalData: studentsData,
      });
      // ✅ STEP 1: Collect all unique chapters from the new response structure
      let allChapters = new Set();
      reportData.forEach((student) => {
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            allChapters.add(ch.chapter);
          });
        }
      });

      const chapterList = Array.from(allChapters).sort();

      // ✅ STEP 2: Prepare student-wise data
      let tableData = [];
      reportData.forEach((student) => {
        const row = {
          name: student.student_name,
          mobile: student.student_mobile,
          chapter_count: student.total_chapter || student.chapters?.length || 0,
        };

        // initialize all chapters with "-"
        chapterList.forEach((chapter) => {
          row[chapter] = "-";
        });

        // fill actual values
        if (student.chapters) {
          student.chapters.forEach((ch) => {
            row[ch.chapter] = ch.error_count;
          });
        }

        tableData.push(row);
      });

      // ✅ STEP 3: Create dynamic columns
      const dynamicColumns = [
        {
          dataField: "name",
          text: "Student Name",
          sort: true,
        },
        {
          dataField: "mobile",
          text: "Mobile",
          sort: true,
        },
        {
          dataField: "chapter_count",
          text: "Chapter Count",
          sort: true,
          formatter: (cell) => (
            <span style={{ fontWeight: "600" }}>{cell}</span>
          ),
        },

        // ✅ Dynamic chapter columns
        ...chapterList.map((chapter) => ({
          dataField: chapter,
          text: chapter.slice(0, 20), // short header
          sort: true,
          headerFormatter: (column) => (
            <span title={chapter} style={{ cursor: "pointer" }}>
              {column.text}
            </span>
          ),
          formatter: (cell) => {
            if (cell === "-") return "-";
            return (
              <span
                title={`${chapter} - ${cell}%`}
                style={{ color: cell > 50 ? "red" : "green", cursor: "pointer" }}
              >
                {cell}%
              </span>
            );
          },
        })),
      ];

      // ✅ FINAL STATE UPDATE
      this.setState({
        adaptiveReportData: apiResult,
        dynamicColumns: dynamicColumns,
        dynamicTableData: tableData,
        showChapterCountsData: false,
        showChapterDetailedData: true,
        previewLoading: false,
      });

    } catch (err) {
      console.log(err, "err");
      this.setState({ previewLoading: false });
      toast.error("Error loading preview: " + (err.message || "Unknown error"));
    }
  };
  handleFormSubmit = async (type) => {
    // Final gate before either creation mutation leaves the client. Re-checked here
    // and not only at the click: this is where the write actually happens, so a stale
    // render or a devtools-forced call still can't create an exam.
    if (!this.requireEdit()) return;

    const {
      nameValue,
      branchValue,
      examValue,
      classTypeValue,
      sectionValue,
      studentValue,
      remedialExamValue,
      selectedScheduleSubType,
      selectedScheduleType,
      errorRangeValue,
      errorRange
    } = this.state;

    // VALIDATIONS
    if (!nameValue || nameValue.trim() === "") {
      toast.error("Please enter exam name");
      this.setState({ examCreationMessage: "Please enter exam name" });
      return;
    }
    if (!errorRange.from && !errorRange.to && selectedScheduleSubType === "4") {
      toast.error("Please select error range");
      this.setState({ examCreationMessage: "Please select error range" });
      return;
    }
    if (branchValue.length === 0) {
      toast.error("Please select branch");
      this.setState({ examCreationMessage: "Please select branch" });
      return;
    }

    if (!examValue) {
      toast.error("Please select exam");
      this.setState({ examCreationMessage: "Please select exam" });
      return;
    }

    if (!classTypeValue) {
      toast.error("Please select class");
      this.setState({ examCreationMessage: "Please select class" });
      return;
    }

    if (!sectionValue.length) {
      toast.error("Please select section");
      this.setState({ examCreationMessage: "Please select section" });
      return;
    }

    // if (!studentValue.length) {
    //   toast.error("Please select students");
    //   this.setState({ examCreationMessage: "Please select students" });
    //   return;
    // }

    if (type === "adaptive_exams" && !selectedScheduleSubType) {
      toast.error("Please select exam type");
      this.setState({ examCreationMessage: "Please select exam type" });
      return;
    }

    if (this.state.isPreviousPaper) {
      if (!this.state.chapterValues || this.state.chapterValues.length === 0) {
        toast.error("Please select chapters");
        return;
      }
      this.setState({ loading: true, examCreationMessage: "" });

      try {
        const student_ids = this.state.studentOptionsCopy.map(s => parseInt(s.value));

        let flatChapterIds = new Set();
        this.state.chapterValues.forEach(ch => {
          let ids = String(ch.value).split(",").map(id => parseInt(id.trim())).filter(id => !isNaN(id));
          ids.forEach(id => flatChapterIds.add(id));
        });
        const chapterIdsArray = Array.from(flatChapterIds);

        const mutationResponse = await this.props.client.mutate({
          mutation: gql`
            mutation CreatePreviousAdaptiveExam(
              $student_ids: [Int]!
              $exam: Int!
              $years: [Int]!
              $chapters: [Int]!
              $name: String!
              $institution_id: Int!
              $schedule_type_id: Int!
              $schedule_sub_type_id: Int!
              $branch_id: String!
              $class_id: Int!
              $section_ids: String!
            ) {
              createPreviousAdaptiveExam(
                student_ids: $student_ids
                exam: $exam
                years: $years
                chapters: $chapters
                name: $name
                institution_id: $institution_id
                schedule_type_id: $schedule_type_id
                schedule_sub_type_id: $schedule_sub_type_id
                branch_id: $branch_id
                class_id: $class_id
                section_ids: $section_ids
              ) {
                exam_paper_id
                filename
              }
            }
          `,
          variables: {
            student_ids: student_ids,
            exam: parseInt(examValue.value),
            years: this.state.selectedYearValue.map(y => parseInt(y.value)),
            chapters: chapterIdsArray,
            name: nameValue,
            institution_id: parseInt(Cookies.get("institutionid")),
            schedule_type_id: parseInt(selectedScheduleType),
            schedule_sub_type_id: parseInt(selectedScheduleSubType),
            branch_id: branchValue.map((item) => item.value).join(","),
            class_id: parseInt(classTypeValue?.value),
            section_ids: sectionValue.map((s) => s.value).join(",")
          }
        });

        this.setState({ loading: false, examCreationMessage: "" });
        toast.success("Previous Adaptive Exam created successfully!");
        if (mutationResponse?.data?.createPreviousAdaptiveExam) {
          this.props.history.push("/questions/manage-question-paper");
        }
      } catch (err) {
        console.error(err);
        this.setState({ loading: false, examCreationMessage: err.message });
        toast.error(err.message || "Something went wrong during creation");
      }
      return;
    }

    let sub_exam_type_val = 0;
    let exam_model_id = 0;
    let mains_2021 = "0";

    if (examValue?.value == 1) {
      exam_model_id = 0;
      mains_2021 = "0";
      sub_exam_type_val = 0;
    } else if (examValue?.value == 2) {
      mains_2021 = "3";
      exam_model_id = 0;
      sub_exam_type_val = 1;
    }
    const modifiedStudentData = studentValue.map((s) => {
      return {
        student_id: s.value,
        student_name: s.label,
        chapters: s.chapters,
      }
    })
    const params = {
      name: nameValue,
      branch_id: branchValue.map((item) => item.value.toString()),
      exam_id: parseInt(examValue.value),
      class_id: parseInt(classTypeValue.value),
      section_ids: sectionValue.map((s) => s.value.toString()),
      student_ids: studentValue.map((s) => s.value.toString()),
      type: type === "remedial_exams" ? "remedial" : "adaptive",
      schedule_type_id: parseInt(this.state.selectedScheduleType),
      schedule_sub_type_id: parseInt(this.state.selectedScheduleSubType),
      adaptive_type_id: parseInt(this.state.selectedAdaptiveTypeId),
      sub_exam_type: parseInt(sub_exam_type_val),
      exam_model_id: exam_model_id,
      mains_2021: mains_2021,
      complexity_type: 4,
      complexity_custom_values: "",
      exam_mode: 1,
      from: errorRange.from,
      to: errorRange.to,
      question_type: "",
      questionbank_questions: "",
      autogenerate: true,
      studentData: studentValue?.length > 0 ? studentValue.map(item => ({
        value: item.value,
        label: item.label,
        chapterCount: item.chapterCount,
        chapters: item.chapters.filter(ch => {
           if (this.state.chapterValues && this.state.chapterValues.length > 0) {
              const selectedIds = this.state.chapterValues.map(c => parseInt(c.value));
              return selectedIds.includes(parseInt(ch.chapter_id));
           }
           return true; 
        }).map(ch => ({
          chapter_id: parseInt(ch.chapter_id),
          chapter: ch.chapter,
          error_count: parseInt(ch.error_count),
        })),
      })) : [],
      institution_id: parseInt(Cookies.get("institutionid")),
      pattern_type: 3
    };

    this.stopJobPolling();
    this.setState({ loading: true, examCreationMessage: "", jobId: null, jobStatus: null, jobProgress: 0, jobTotal: 0, jobError: null, showJobModal: false });
    console.log(params, "params");
    try {
      const response = await this.props.handleCreate({
        variables: { params }
      });

      const job = response?.data?.createAdaptiveExamMadeEasy;
      if (job && job.jobId) {
        this.setState({ jobId: job.jobId, jobTotal: job.total || 0, jobStatus: "pending", showJobModal: true });
        this.startJobPolling(job.jobId);
      } else {
        this.setState({ loading: false });
        toast.success("Exam created successfully!");
        this.props.history.push("/questions/manage-question-paper");
      }

    } catch (err) {
      console.log(err, "err");
      this.setState({ loading: false, examCreationMessage: err.message });
      toast.error(err.message || "Something went wrong during exam creation");
    }
  };


  // Click handler for both "Create Exam" buttons (the inline one and the preview
  // modal's). Creating an exam is a write → is_edit. The button is never disabled, so
  // a view-only role clicks it, gets Access Denied, and the creation is skipped.
  handleConfirmExamCreation = () => {
    if (!this.requireEdit()) return;

    this.handleFormSubmit("adaptive_exams");
  };



  handleScheduleTypeChange = (item) => {
    console.log(item, "item");
    const isPrevious = item?.schedule_sub_type === "Previous Paper" || String(item?.schedule_sub_type_id) === "5";
    this.setState({
      selectedScheduleType: item.schedule_type_id,
      selectedScheduleSubType: item.schedule_sub_type_id,
      selectedAdaptiveTypeId: item.adaptive_type_id,
      isPreviousPaper: isPrevious,
      showChapterDetailedData: false,
      selectedYear: null,
      errorRangeValue: null,
      dynamicTableData: [],
      dynamicColumns: [],
      showPrevPap: isPrevious,
    });
  };
  handleQuestionPaperTypeChange = (item) => {
    console.log(item, "item");
    this.setState({
      questionPaperType: item.value,
      showChapterCountsData: false,
      showChapterDetailedData: false,
    });
  }

  handleErrorRangeChange = (type, value) => {
    let num = value === "" ? "" : parseInt(value, 10);

    if (num !== "" && isNaN(num)) return;

    // restrict 0–100
    if (num !== "" && (num < 0 || num > 100)) return;

    this.setState((prevState) => ({
      errorRange: {
        ...prevState.errorRange,
        [type]: num,
        showChapterCountsData: false,
        showChapterDetailedData: false,
        chapterValues: [],
        studentValue: [],

      },
    }));
  };

  renderTabsUI = (type, isCreation) => {
    const typeLower = type.toLowerCase().replace(" ", "_");

    // const manageExamOptions = (
    //   this.props.manageQuestionsForDropdown ||
    //   this.props.manageQuestions ||
    //   []
    // ).map((m) => ({
    //   label: m.name,
    //   value: m.id,
    // }));

    const subTabKey =
      typeLower === "adaptive_exams" ? "adaptiveSubTab" : "remedialSubTab";
    const questionPaperTypes = [
      {
        label: "College Questions",
        value: 1
      },
      {
        label: "Rizee Questions",
        value: 2
      }
    ]





    return (
      <Tab.Container
        activeKey={this.state[subTabKey]}
        onSelect={(k) => this.setState({ [subTabKey]: k })}
        mountOnEnter
        unmountOnExit
      >

        {/* <Nav className="sub-tabs">
          <Nav.Item>
            <Nav.Link eventKey={`manage_${typeLower}`}>
              <i className="fas fa-list" /> Manage
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey={`create_${typeLower}`}>
              <i className="fas fa-plus-circle" /> Create
            </Nav.Link>
          </Nav.Item>
        </Nav> */}

        {/* <Tab.Pane eventKey={`create_${typeLower}`}> */}
        <Card className="adaptive-form-card">
          {/* {typeLower === "adaptive_exams" && ( */}
          <Row className="form-row">
            <Col sm={12}>
              <Form.Group>
                {this.state.adaptiveScheduledTypes.map((item) => (
                  <Form.Check
                    key={item.schedule_sub_type_id}
                    id={`schedule-${item.schedule_sub_type_id}`}
                    inline
                    type="radio"
                    name="adaptive_schedule_type"
                    label={item?.schedule_sub_type && item?.schedule_sub_type == "Chapter Test" ? "Strength Wise" : item?.schedule_sub_type}
                    checked={
                      this.state.selectedScheduleSubType ===
                      item.schedule_sub_type_id
                    }
                    onChange={() => this.handleScheduleTypeChange(item)}
                  />
                ))}
              </Form.Group>
            </Col>
            {/* {(this.state.selectedScheduleSubType === "4") && <Col>
              <Form.Group>
                {questionPaperTypes.map((item) => (
                  <Form.Check
                    key={item.value}
                    id={`question_paper_type-${item.value}`}
                    inline
                    type="radio"
                    name="question_paper_type"
                    label={item.label}
                    checked={
                      this.state.questionPaperType ===
                      item.value
                    }
                    onChange={() => this.handleQuestionPaperTypeChange(item)}
                  />
                ))}
              </Form.Group>
            </Col>} */}

          </Row>
          {/* )} */}

          <div className="zIndexCls">
            <Row className="form-row">

              <Col sm={6}>
                <Form.Label>Name</Form.Label>

                <Form.Control
                  name="name"
                  type="text"
                  placeholder={`Name of the ${type}`}
                  onChange={this.handleInputChange}
                  value={this.state.nameValue || ""}
                />
              </Col>
              {(this.state.isPreviousPaper) && <Col sm={3}>
                <Form.Group>
                  <Form.Label>Select Year</Form.Label>
                  <MultiSelect
                    options={this.state.previousYearOptions}
                    value={this.state.selectedYearValue}
                    onChange={(e) =>
                      this.handleMultipleSelectInputChange(e, "selectedYear")
                    }
                    labelledBy={"selectedYear"}
                    name="selectedYear"

                  />
                </Form.Group>
              </Col>}
              {(!this.state.isPreviousPaper) && <Col sm={4}>
                <Col sm={12}>
                  <Form.Label>Error Range (%)</Form.Label>

                  <div style={{ display: "flex", gap: 8 }}>
                    {/* FROM */}
                    <Form.Control
                      type="number"
                      placeholder="From"
                      min={0}
                      max={100}
                      value={this.state.errorRange?.from || ""}
                      onChange={(e) =>
                        this.handleErrorRangeChange("from", e.target.value)
                      }
                    />

                    <span style={{ alignSelf: "center" }}>–</span>

                    {/* TO */}
                    <Col sm={6}>
                      <Form.Control
                        type="number"
                        placeholder="To"
                        min={0}
                        max={100}
                        value={this.state.errorRange?.to || ""}
                        onChange={(e) =>
                          this.handleErrorRangeChange("to", e.target.value)
                        }
                      />
                      {this.state.errorRange?.from !== "" &&
                        this.state.errorRange?.to !== "" &&
                        this.state.errorRange.to < this.state.errorRange.from && (
                          <small style={{ color: "red" }}>
                            "To" should be greater than or equal to "From"
                          </small>
                        )}
                    </Col>
                  </div>
                </Col>
              </Col>}
              {/* <Col sm={2}>
                <Form.Label>No. of Questions</Form.Label>
                <Form.Control
                  name="noOfQuestions"
                  type="number"
                  min={0}
                  max={200}
                  placeholder="No. of Questions"
                  onChange={this.handleInputChange}
                  value={this.state.noOfQuestionsValue || ""}
                />
              </Col> */}
            </Row>

            <Row className="form-row">
              <Col sm={3}>
                <Form.Label>Branch</Form.Label>
                {/* <SelectDropDown
                          stateData={this.state.branchValue}
                          handleChange={this.selecthandleInputChange}
                          name="branch"
                          options={this.state.branchTypeOptions}
                          dropdownIndicator={{ DropdownIndicator }}
                        /> */}

                {/* <MultiSelect
                          overrideStrings={{
                            "allItemsAreSelected": "All Branches are selected.",
                            "selectSomeItems": branchlabelledBy
                          }}  
                          disableSearch={classdisableSearch}
                          hasSelectAll={branchselectall}
                          options={this.state.branchTypeOptions}
                          value={this.state.branchValue}
                          onChange={(e) => this.handleMultipleSelectInputChange(e, "branch")}
                          labelledBy={"class"}
                          name="branch"
                        /> */}

                <MultiSelect
                  options={this.state.branchTypeOptions}
                  value={this.state.branchValue}
                  onChange={(e) =>
                    this.handleMultipleSelectInputChange(e, "branch")
                  }
                  labelledBy="Select Branch"
                />
              </Col>

              <Col sm={3}>
                <Form.Label>Exam</Form.Label>
                <SelectDropDown
                  stateData={this.state.examValue}
                  handleChange={this.selecthandleInputChange}
                  name="exam"
                  options={this.state.examTypeOptions}
                  dropdownIndicator={{ DropdownIndicator }}
                />
              </Col>

              <Col sm={3}>
                <Form.Label>Class</Form.Label>
                <SelectDropDown
                  stateData={this.state.classTypeValue}
                  handleChange={this.selecthandleInputChange}
                  name="classType"
                  options={this.state.classOptions}
                  dropdownIndicator={{ DropdownIndicator }}
                />
              </Col>

              <Col sm={3}>
                <Form.Label>Section</Form.Label>
                <MultiSelect
                  options={this.state.sectionOptionsCopy}
                  value={this.state.sectionValue}
                  onChange={(e) =>
                    this.handleMultipleSelectInputChange(e, "section")
                  }
                  labelledBy="Select"
                />
              </Col>
            </Row>
            {this.state.subjectOptions.length > 0 && this.state.isPreviousPaper && (
              <Row className="mt-3">
                <Col sm={3}>
                  <Form.Label>Subjects</Form.Label>
                  <SelectDropDown
                    stateData={this.state.subjectValue}
                    handleChange={this.selecthandleInputChange}
                    name="subject"
                    options={this.state.subjectOptions}
                    dropdownIndicator={{ DropdownIndicator }}
                  />
                </Col>
              </Row>
            )}
            {this.state.chaptersData.length > 0 && (
              <Row className="mt-3">
                <Col sm={3}>
                  <Form.Label>Chapters</Form.Label>
                  <MultiSelect
                    options={this.state.chaptersData}
                    value={this.state.chapterValues}
                    onChange={(e) =>
                      this.handleMultipleSelectInputChange(e, "chapter")
                    }
                    labelledBy="Select Chapters"
                  />
                </Col>

                <Col sm={3}>
                  <Form.Label>Students</Form.Label>
                  <div className="multiselect-wrapper">
                    <MultiSelect
                      options={this.state.chapterwiseStudents}
                      value={this.state.studentValue}
                      onChange={(e) =>
                        this.handleMultipleSelectInputChange(e, "student")
                      }
                      labelledBy="Select Students"
                    />
                  </div>
                </Col>
              </Row>
            )}
          </div>
          {(this.state.showChapterDetailedData && this.state.dynamicTableData.length === 0 && !this.state.isPreviousPaper) ? (

            <div className="text-danger font-weight-bold">
              ❌ All students have No Weak Areas. Exam cannot be created.
            </div>) :
            (
              <div>
                {this.state.showChapterDetailedData && <DataTableWithOutSearch
                  parentData={this.state.dynamicTableData}
                  particlecolumns={this.state.dynamicColumns}
                  // tableHeading={{ Title: `Manage ${type}` }}
                  name={`Exam Conduting Students`}
                />
                }
                {this.state.examNotConductedStundets.length > 0 && <DataTableWithOutSearch
                  parentData={this.state.examNotConductedStundets}
                  particlecolumns={this.state.dynamicColumns}
                  // tableHeading={{ Title: `Manage ${type}` }}
                  name={`Exam Not Conducted Students`}
                />
                }

              </div>)}


          <div className="form-submit">
            {((this.state.showChapterDetailedData && this.state.dynamicTableData.length > 0) || (this.state.isPreviousPaper && this.state.chapterValues.length > 0)) ?
              <Button
                variant="primary"
                onClick={this.handleConfirmExamCreation}
                disabled={this.state.loading}
              >
                {this.state.loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Creating...
                  </>
                ) : (
                  "Create Exam"
                )}
              </Button> : <Button
                className="submit-btn"
                onClick={this.handleForExamCreationForAdaptive}
                disabled={this.state.previewLoading}
              >
                {this.state.previewLoading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Loading...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>}
          </div>

        </Card>
        {/* </Tab.Pane> */}



      </Tab.Container>
    );
  };

  render() {
    const isCreation = this.props.type === "creation";

    const studentsData = this.state.studentExamPercErrorArr || [];

    const successStudents = studentsData.filter(s => s.status === "success");
    const noWeakStudents = studentsData.filter(s => s.status !== "success");

    const isAllNoWeak = successStudents.length === 0;


    let branchselectall = true;
    let branchlabelledBy = "Select";
    let branchdisableSearch = false;

    if (this.props.globals.globalBranches.length > 0) {
      branchselectall = true;
      branchdisableSearch = false;
    }
    else {
      branchdisableSearch = true;
      branchselectall = false;
      branchlabelledBy = "Branch"
    }



    return (
      <Container fluid className="adaptive-exams-wrapper">
        <ToastContainer position="top-right" autoClose={3000} />
        {/* <Tab.Container
          defaultActiveKey="adaptive_exams"
          mountOnEnter
          unmountOnExit
          onSelect={(k) => {
            this.resetForm();
            this.setState({
              selectedScheduleType: null,
              selectedScheduleSubType: null
            });

            this.props.onTabChange && this.props.onTabChange(k);
          }}
        > */}
        <div className="adaptive-main-tabs-container">
          {/* <Nav className="main-adaptive-nav"> */}
          {/* <Nav.Item>
                <Nav.Link eventKey="adaptive_exams">
                  <i className="fas fa-brain" /> Adaptive Exams
                </Nav.Link>
              </Nav.Item> */}

          {/*<Nav.Item>
                <Nav.Link eventKey="remedial_exams">
                  <i className="fas fa-users-cog" /> Remedial Exams
                </Nav.Link>
              </Nav.Item>*/}
          {/* </Nav> */}
        </div>

        {/* <Tab.Content className="adaptive-content"> */}
        {this.props.isExamsLoading && (
          <div className="adaptive-loading">
            <Spinner animation="border" />
          </div>
        )}

        {/* <Tab.Pane eventKey="adaptive_exams"> */}
        {this.renderTabsUI("Adaptive Exams", isCreation)}
        {/* </Tab.Pane> */}

        {/* <Tab.Pane eventKey="remedial_exams">
              {this.renderTabsUI("Remedial Exams")}
            </Tab.Pane> */}
        {/* </Tab.Content>
        </Tab.Container> */}


        <Modal
          show={this.state.showPreviewModal}
          onHide={() => this.setState({ showPreviewModal: false })}
          dialogClassName="student-analysis-modal"
        >

          <Modal.Header closeButton>
            <Modal.Title>Student Error Analysis</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {this.state.previewLoading ? (

              <div className="text-center">
                <Spinner animation="border" />
              </div>

            ) : (

              <div>

                {/* STUDENT TABS */}
                <div className="student-tabs-wrapper">

                  <button
                    className="scroll-btn left"
                    onClick={() => this.studentTabsRef.scrollBy({ left: -200, behavior: "smooth" })}
                  >
                    ‹
                  </button>

                  <div
                    className="student-tabs-scroll"
                    ref={(ref) => (this.studentTabsRef = ref)}
                  >
                    <Nav variant="tabs" className="student-tabs">

                      {this.state.studentExamPercErrorArr.map((student, index) => (

                        <Nav.Item key={index}>

                          <Nav.Link
                            active={this.state.activeStudentIndex === index}
                            onClick={() =>
                              this.setState({
                                activeStudentIndex: index,
                                errorViewType: "greater"
                              })
                            }
                          >
                            {student.student_name}
                          </Nav.Link>

                        </Nav.Item>

                      ))}

                    </Nav>
                  </div>

                  <button
                    className="scroll-btn right"
                    onClick={() => this.studentTabsRef.scrollBy({ left: 200, behavior: "smooth" })}
                  >
                    ›
                  </button>

                </div>


                {/* ERROR TYPE TABS 

        <Nav variant="pills" className="mb-3 error-type-tabs">

          <Nav.Item>
            <Nav.Link
              active={this.state.errorViewType === "greater"}
              onClick={() => this.setState({ errorViewType: "greater" })}
            >
              &gt;&nbsp;60 % Error Rate
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              active={this.state.errorViewType === "lesser"}
              onClick={() => this.setState({ errorViewType: "lesser" })}
            >
              &lt;&nbsp;60 % Error Rate
            </Nav.Link>
          </Nav.Item>

        </Nav>*/}


                {/* SUBJECT CARDS */}

                {studentsData.length > 0 && (() => {

                  const activeStudent = studentsData[this.state.activeStudentIndex];

                  if (!activeStudent) return null;

                  // ❌ NO WEAK AREAS UI
                  if (activeStudent.status !== "success") {
                    return (
                      <div className="text-center mt-4">
                        <h5 className="text-danger">No Weak Areas</h5>
                        <p>This student has no chapters with error &gt; 60%</p>
                      </div>
                    );
                  }

                  // ✅ SHOW SUBJECTS
                  return (
                    <Row className="subjects-row">

                      {activeStudent.subjects.map((sub, sIndex) => {

                        const chapters =
                          this.state.errorViewType === "greater"
                            ? sub.greaterthan60PercErrorChapters
                            : sub.lessthan60PercErrorChapters;

                        if (!chapters || chapters.length === 0) return null;

                        return (
                          <Col md={4} key={sIndex} className="subject-col">
                            <Card className="subject-card h-100">
                              <Card.Body className="subject-card-body">

                                <h6 className="subject-title">{sub.subject}</h6>

                                <ul className={`chapter-list ${chapters.length > 5 ? "chapter-scroll" : ""}`}>
                                  {chapters.map((chap, cIndex) => (
                                    <li key={cIndex}>
                                      <span className="chapter-name">{chap.chapter}</span>
                                      <span className="error-percentage">{chap.error}%</span>
                                    </li>
                                  ))}
                                </ul>

                              </Card.Body>
                            </Card>
                          </Col>
                        );

                      })}

                    </Row>
                  );

                })()}

              </div>

            )}

          </Modal.Body>

          <Modal.Footer>

            <Button
              variant="secondary"
              onClick={() => this.setState({ showPreviewModal: false })}
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              onClick={this.handleConfirmExamCreation}
              disabled={this.state.loading || isAllNoWeak}

            >

              {this.state.loading ? (
                <>
                  <Spinner animation="border" size="sm" /> Creating...
                </>
              ) : (
                "Create Exam"
              )}

            </Button>

            {studentsData.length > 0 && (

              <div className="text-center mt-2">

                {isAllNoWeak ? (

                  <div className="text-danger font-weight-bold">
                    ❌ All students have No Weak Areas. Exam cannot be created.
                  </div>

                ) : (

                  // <div className="text-success">

                  //   ✅ Exams will be created for:
                  //   <br />

                  //   <strong>
                  //     {successStudents.map(s => s.student_name).join(", ")}
                  //   </strong>

                  //   {noWeakStudents.length > 0 && (
                  //     <>
                  //       <br />
                  //       <span className="text-muted">
                  //         Skipped (No Weak Areas):
                  //         {" "}
                  //         {noWeakStudents.map(s => s.student_name).join(", ")}
                  //       </span>
                  //     </>
                  //   )}

                  // </div>
                  ""
                )}

              </div>

            )}

            {this.state.examCreationMessage && (
              <Row>
                <Col>
                  <div className="exam-message text-center">
                    {this.state.examCreationMessage}
                  </div>
                </Col>
              </Row>
            )}

          </Modal.Footer>

        </Modal>

        {/* Job Progress Modal */}
        <Modal
          show={!!this.state.jobId}
          centered
          backdrop="static"
          keyboard={false}
          size="sm"
        >
          <Modal.Body style={{ padding: "28px 24px", textAlign: "center" }}>
            {this.state.jobStatus === "done" ? (
              <>
                <div style={{ fontSize: 44, marginBottom: 8 }}>✅</div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Exams Created Successfully!</div>
                <div style={{ color: "#666", fontSize: 13, marginBottom: 20 }}>
                  {this.state.jobTotal} exam{this.state.jobTotal !== 1 ? "s" : ""} have been created.
                </div>
                <Button
                  variant="primary"
                  size="sm"
                  style={{ width: "100%" }}
                  onClick={() => {
                    localStorage.removeItem(jobStorageKey());
                    this.setState({ jobId: null, jobStatus: null, jobProgress: 0, jobTotal: 0, jobError: null });
                    this.props.history.push("/questions/manage-question-paper");
                  }}
                >
                  View Exams
                </Button>
              </>
            ) : this.state.jobStatus === "failed" ? (
              <>
                <div style={{ fontSize: 44, marginBottom: 8 }}>❌</div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Creation Failed</div>
                <div style={{ color: "#ef4444", fontSize: 13, marginBottom: 20 }}>
                  {this.state.jobError || "Something went wrong. Please try again."}
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  style={{ width: "100%" }}
                  onClick={() => {
                    localStorage.removeItem(jobStorageKey());
                    this.setState({ jobId: null, jobStatus: null, jobProgress: 0, jobTotal: 0, jobError: null });
                  }}
                >
                  Close
                </Button>
              </>
            ) : (
              <>
                <Spinner animation="border" variant="primary" style={{ width: 40, height: 40, marginBottom: 14 }} />
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>Creating Exams...</div>
                <div style={{ color: "#666", fontSize: 13, marginBottom: 14 }}>
                  Please wait. Do not close this window.
                </div>
                <div style={{ background: "#e9ecef", borderRadius: 8, height: 10, overflow: "hidden", marginBottom: 8 }}>
                  <div style={{
                    width: `${this.state.jobTotal > 0 ? Math.round((this.state.jobProgress / this.state.jobTotal) * 100) : 5}%`,
                    background: "linear-gradient(90deg, #2647ea, #3b82f6)",
                    height: "100%",
                    borderRadius: 8,
                    transition: "width 0.4s ease",
                  }} />
                </div>
                <div style={{ color: "#888", fontSize: 12 }}>
                  {this.state.jobProgress} of {this.state.jobTotal} exams created
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* Shown instead of creating / deleting / navigating when the grant is
            missing. One modal serves every intercepted action. */}
        <Modal
          show={this.state.accessDeniedShow}
          onHide={this.hideAccessDenied}
          centered
          size="sm"
          aria-labelledby="adaptive-exams-access-denied"
        >
          <Modal.Body className="text-center" style={{ padding: "28px 24px" }}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#fef2f2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <i className="fal fa-lock-alt" style={{ fontSize: 26 }} />
            </div>
            <h5 id="adaptive-exams-access-denied" style={{ fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
              Access Denied
            </h5>
            <p style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>
              You don't have permission to perform this action.
            </p>
            <Button variant="secondary" onClick={this.hideAccessDenied}>Close</Button>
          </Modal.Body>
        </Modal>

      </Container>
    );
  }
}

export default withRouter(withApollo(CreateAdaptiveExams));
